export const JOB_LEVEL_ALIAS_MAX_LENGTH = 5;

export const normalizeFieldRows = (fields) => fields.map((row) => {
  const show = Boolean(row.show);
  const required = show && Boolean(row.required);

  return { ...row, show, required };
});

export const truncateShortName = (shortName) => {
  if (shortName == null || shortName === '') return '';

  return String(shortName).slice(0, JOB_LEVEL_ALIAS_MAX_LENGTH);
};

export const normalizeLevelRows = (levels) => levels.map((row, index) => ({
  ...row,
  short_name: truncateShortName(row.short_name),
  order: index,
}));

export const withOrderIndex = (rows) => rows.map((row, index) => ({
  ...row,
  order: index,
}));

export const validateForSave = ({ fields, levels }) => {
  const errors = [];
  const normalizedFields = normalizeFieldRows(fields);

  if (
    normalizedFields.length > 0
    && !normalizedFields.some((field) => field.show)
  ) {
    errors.push('At least one profile field must be visible.');
  }

  levels.forEach((row) => {
    if (row.short_name != null && String(row.short_name).length > JOB_LEVEL_ALIAS_MAX_LENGTH) {
      errors.push(`Alias for "${row.name}" must be at most ${JOB_LEVEL_ALIAS_MAX_LENGTH} characters.`);
    }
  });

  return {
    ok: errors.length === 0,
    errors,
  };
};
